import { Paper } from "@mui/material";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import SchemeDetails from "./SchemeDetails";
import SchemeScope from "./SchemeScope";
import "./Scheme.css";
import SchemeLevelDetails from "./SchemeLevelDetails";
import SchemeProductList from "./SchemeProductList";
import { useRef, useState } from "react";
import { areYouSureMsg, noInternetMsg, savemsg, saveWarningMsg, serverMsg } from "../../config/messageconstant";
import { apiPost } from "../../utils/api_service";
import endpoint from "../../config/endpoints";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getFormattedDateWithConvertingObj } from "../../utils/dateFormat";


const Scheme = ({
    showLoador,
    showNotification,
}) => {
    const navigate = useNavigate();

    const SchemeScopeRef = useRef(null);
    const SchemeDetailsRef = useRef(null);
    const SchemeLevelRef = useRef(null);
    const SchemeProductDetailsRef = useRef(null);
    const [offerDetailsData, setOfferDetailsData] = useState(null);
    const [offerLevelDetailsData, setOfferLevelDetailsData] = useState(null);



    const submitHandler = () => {

        const scopeResult = SchemeScopeRef.current?.validate();
        const detailsResult = SchemeDetailsRef.current?.validate();
        const levelResult = SchemeLevelRef.current?.validate();

        if (
            !scopeResult?.isValid ||
            !detailsResult?.isValid ||
            !levelResult?.isValid
        ) {
            return;
        }

        const productDetails = SchemeProductDetailsRef.current?.getData();

        const schemeConditionsData = SchemeLevelRef.current?.schemeConditionsDetails();

        const payload = {
            scope: SchemeScopeRef.current.getData(),
            details: SchemeDetailsRef.current.getData(),
            level: SchemeLevelRef.current.getData(),
        };

        if (productDetails) {
            payload.productDetails = productDetails;
        } else {
            payload.productDetails = [];
        }

        if (schemeConditionsData && schemeConditionsData?.schemeConditionsData) {
            payload.schemeConditionsData = schemeConditionsData?.schemeConditionsData;
        } else {
            payload.schemeConditionsData = {};
        }

        saveOfferData(payload);
    };

    const groupSlabsByDate = (payload) => {
        const grouped = {};

        payload.schemeConditionsData.rows.forEach((slab) => {
            const fromDate = getFormattedDateWithConvertingObj(slab.fromDate);
            const toDate = getFormattedDateWithConvertingObj(slab.toDate);
            const key = `${fromDate}_${toDate}`;

            if (!grouped[key]) {
                grouped[key] = {
                    fromDate,
                    toDate,
                    offerSlabWiseData: []
                };
            }

            grouped[key].offerSlabWiseData.push({
                minValue: slab.valueType == 0 ? slab.minQty : slab.minValue,
                maxValue: slab.valueType == 0 ? slab.maxQty : slab.maxValue,
                discount: slab.discount,
                fromDate,
                toDate,
                valueType: slab.valueType,
                inclusiveProductIds: payload?.schemeConditionsData?.inclusiveProducts.map(d => d.id).join(","),
                exclusiveProductIds: slab.exclusiveProductIds.map(d => d.id).join(","),
            });
        });

        return Object.values(grouped);
    };

    const saveOfferData = (payload) => {

        let qty = null;

        let maxValue = null;

        let flatAmt = null;

        let flatDiscountPer = null;

        const levelId = payload?.level?.levelType?.id;

        if ([8, 9, 10].includes(levelId)) {
            qty = payload?.schemeConditionsData?.formData?.minQty || null;
            maxValue = payload?.schemeConditionsData?.formData?.maxQty || null;
            flatAmt = payload?.schemeConditionsData?.formData?.amount || null;
        } else if (levelId === 11) {
            qty = payload?.schemeConditionsData?.formData?.minValue || null;
            maxValue = payload?.schemeConditionsData?.formData?.maxValue || null;
            flatDiscountPer = payload?.schemeConditionsData?.formData?.discount || null;
        } else {
            qty = payload?.level?.productQty || null;
            flatDiscountPer = payload?.level?.discountPercentage || null;
        }



        let productIds = "";

        if ([7, 8, 9].includes(levelId)) {
            productIds = Array.isArray(payload?.level?.productMultiple)
                ? payload.level.productMultiple.map(p => p.id).join(",")
                : "";
        }
        else if ([10, 11].includes(levelId)) {
            productIds = Array.isArray(payload?.schemeConditionsData?.selectedProducts)
                ? payload.schemeConditionsData.selectedProducts.map(p => p.id).join(",")
                : "";
        }
        else {
            productIds = payload?.level?.product?.id || "";
        }

        let offerDataObject = {
            name: payload?.details?.offerName || "",
            discription: payload?.details?.description || "",
            fromDate: payload?.details?.fromDate === "" ? null :
                getFormattedDateWithConvertingObj(payload?.details?.fromDate),
            toDate: payload?.details?.toDate === "" ? null :
                getFormattedDateWithConvertingObj(payload?.details?.toDate),
            type: 0,
            isPanIndia: payload?.scope?.scopeType || 0,
            fromRangeDate: null,
            toRangeDate: null,
            offerFor: payload?.details?.applicableOn === "" ? null :
                payload?.details?.applicableOn,

            stockStakeHolderType:
                payload?.details?.stakeholderType?.id
                    ? { id: payload.details.stakeholderType.id }
                    : null,
            level: payload?.details?.offerLevel === "" ? null :
                payload?.details?.offerLevel,
            levelWiseType: payload?.level?.levelType === "" ? null :
                payload?.level?.levelType?.id,
            applicableAmount: payload?.level?.applicableAmount === "" ? null :
                payload?.level?.applicableAmount,
            discountAmount: payload?.level?.discountAmount === "" ? null :
                payload?.level?.discountAmount,
            discountPercentage: flatDiscountPer,
            productIds: productIds,
            categoryIds:
                payload?.level?.categories?.map(item => item.id).join(",") || "",
            regionId: payload?.scope?.scopeType == 0 ? (payload?.scope?.region?.id === "" ? null : payload?.scope?.region?.id) : 0,
            stateId: payload?.scope?.scopeType == 0 ? (payload?.scope?.state?.id === "" ? null : payload?.scope?.state?.id) : 0,
            zoneIds:
                payload?.scope?.scopeType == 0
                    ? Array.isArray(payload?.scope?.zone) && payload.scope.zone.length > 0
                        ? payload.scope.zone.map(z => z.id).join(",")
                        : null
                    : 0,
            districtIds:
                payload?.scope?.scopeType == 0 ?
                    Array.isArray(payload?.scope?.district) && payload?.scope?.district.length > 0
                        ? payload.scope.district.map(z => z.id).join(",")
                        : null
                    : 0,
            talukaIds:
                payload?.scope?.scopeType == 0 ?
                    Array.isArray(payload?.scope?.taluka) && payload?.scope?.taluka.length > 0
                        ? payload.scope.taluka.map(z => z.id).join(",")
                        : null
                    : 0,
            areaIds: payload?.scope?.scopeType == 0 ?
                Array.isArray(payload?.scope?.area) && payload?.scope?.area.length > 0
                    ? payload.scope.area.map(z => z.id).join(",")
                    : null
                : 0,
            qty: qty,
            maxValue: maxValue,
            flatAmount: flatAmt,
            calculatedBy: payload?.details?.calculatedBy === "" ? null : payload?.details?.calculatedBy,
            offerType: payload?.details?.offerType === "" ? null : payload?.details?.offerType,
            isActive: "1",
            calculationType: Object.keys(offerLevelDetailsData).length !== 0 ? offerLevelDetailsData?.isReverseCalculation ?? 0 : 0,
            offerDetails:
                payload?.productDetails.length !== 0
                    ? payload?.productDetails.map((offerObject) => {
                        let offerData = {
                            product: {
                                id: offerObject.productId,
                            },
                            qty: offerObject.qty == "-" ? null : offerObject.qty,
                            percentage:
                                offerObject.percentage == "-" ? null : offerObject.percentage,
                        };
                        return offerData;
                    })
                    : [],

            offerSlabDate: Object.keys(payload?.schemeConditionsData).length !== 0 && payload?.schemeConditionsData?.rows.length !== 0
                ? groupSlabsByDate(payload)
                : [],
        };

        if (navigator.onLine) {
            swal({
                title: areYouSureMsg,
                text: saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    await apiPost({
                        url: endpoint.offer + "/slab-wise-save",
                        postBody: offerDataObject,
                    }).then(({ data, success }) => {
                        if (success) {
                            showNotification({ msg: savemsg, });
                            navigate(-1);
                        } else {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    });
                    showLoador({ loador: false });
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    const onCancel = () => {
        navigate(-1);
    }

    return (
        <Paper sx={{ p: 2, borderRadius: 2 }} elevation={0}>
            <LandingScreenHeader
                screenTitle="Scheme Master"
                showTable={false}
                showBackButton={true}
                showAddButton={false}
                onCancel={onCancel}
            />

            <div className="container-scheme">
                {/* OFFER SCOPE */}
                <SchemeScope ref={SchemeScopeRef} />
                {/* OFFER DETAILS */}
                <SchemeDetails ref={SchemeDetailsRef} onChange={setOfferDetailsData} />
                {/* OFFER LEVEL DETAILS */}
                <SchemeLevelDetails
                    ref={SchemeLevelRef}
                    offerDetails={offerDetailsData}
                    onChange={setOfferLevelDetailsData}
                />


                {/* PRODUCT DETAILS */}
                {(offerLevelDetailsData?.levelType?.id == 3 ||
                    offerLevelDetailsData?.levelType?.id == 4 ||
                    offerLevelDetailsData?.levelType?.id == 5 ||
                    offerLevelDetailsData?.levelType?.id == 6 ||
                    offerLevelDetailsData?.levelType?.id == 7) &&
                    <SchemeProductList
                        ref={SchemeProductDetailsRef}
                        offerLevelDetailsData={offerLevelDetailsData}

                    />}
            </div>

            <div className="sticky-footer-scheme">
                <button className="sub-button" onClick={submitHandler}>
                    Submit Offer
                </button>
            </div>
        </Paper>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
    showLoador,
    showNotification,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
})(Scheme);

